
export const bateriaVirtualFixDecimals = (contractsList, decimals=0) => {
  const items = [...contractsList];
  for (let item of items) {
    for (let bv of (item?.bateria_virtual ?? [])) {
      bv.pes_percentatge = parseInt(bv.pes_percentatge.toFixed(decimals));
    }
  }
  return items;
};